<template>
  <q-dialog :value="!!userSync" :persistent="isLoading" @hide="userSync = null">
    <q-card style="width: 25rem; max-width: 80vw">
      <q-card-section>
        <h6>{{ title }}</h6>
      </q-card-section>

      <q-card-section v-if="!!user">
        <slot />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn v-close-popup flat color="muted" :disable="isLoading" label="cancel" />
        <q-btn color="primary" label="Confirm" :loading="isLoading" @click="handleConfirm" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { getErrorMessage } from '@/utils';

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      default: () => {},
      validator: (value) => value === null || Object.keys(value).length > 0,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    userSync: {
      get() {
        return this.user;
      },
      set(val) {
        this.$emit('update:user', val);
      },
    },
  },

  methods: {
    async handleConfirm() {
      this.isLoading = true;

      try {
        await this.onConfirm();
      } catch (error) {
        this.$q.notify({ message: getErrorMessage(error), type: 'negative' });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
